import React, { useContext } from "react";
import { AppointmentContext } from "../context/AppointmentContext";

function Appointment({ onNext, onPrevious, onReset }) {
  const { setAppointmentType } = useContext(AppointmentContext);
  const { hospitalName } = useContext(AppointmentContext);
  const handleSelection = (type) => {
    setAppointmentType(type);
    onNext();
  };
  return (
    <>
      <div className="card shadow-sm border-0" >
        <div className="card-body">
          <h5 className="text-success fw-bold">
            {hospitalName === "hazra"
              ? " Chittaranjan National Cancer Institute, Hazra, Kolkata"
              : "Chittaranjan National Cancer Institute, New Town, Kolkata"}
          </h5>
          <h5 className="mb-4 fw-bold">
            <i class="fa fa-check-circle" aria-hidden="true"></i>&nbsp;
            Select Appointment Type</h5>

          <div className="custom-option" role="button">
            <div onClick={() => handleSelection("New Appointment")}
              className="list-group-item hospital-item mb-2 d-flex justify-content-between align-items-center"
              style={{ cursor: "pointer" ,backgroundColor:"LIGHTCYAN"}}
            >
              <div>
                <div className="fw-semibold">
                  <span> New Appointment</span>&nbsp;&nbsp;
                  {/* <i className="fas fa-person-walking fa-lg text-primary"></i> */}
                </div>
                <small className="text-muted">
                  ( Don’t have UHID/Registration Number )
                </small>
              </div>
              <i className="fa fa-chevron-right text-dark"></i>
            </div>
          </div>
          <div
            className="list-group mb-4"
            style={{ maxHeight: "200px", overflowY: "auto" }}
          >
            <div
              className="list-group-item mb-2 d-flex justify-content-between align-items-center"
style={{ backgroundColor:"lightgrey"}}
            >
              <div>
                <div className="fw-semibold">
                  <span> Followup Appointment</span>&nbsp;&nbsp;
                  {/* <i className="fas fa-person-walking fa-lg text-primary"></i> */}
                </div>
                <small className="text-muted">
                  ( Have UHID/ Registration Number )
                </small>
                <br></br>
                <small>
                  <b>
                    ** This hospital is not offering follow-up appointment
                    through ORS. For follow-up treatment please visit hospital
                    as per OPD/Clinic schedule.
                  </b>
                </small>
              </div>
              {/* <i className="fa fa-chevron-right text-dark"></i> */}
            </div>
          </div>
          <p><span style={{ fontWeight: "600", color: "red" }}>NOTE **</span> <span style={{ fontWeight: "600" }}>Please check your OPD Card for UHID/ Registration Number</span></p>
          <div className="d-flex justify-content-between mt-4">
            <button
              onClick={onPrevious}
              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-800 text-white text-sm font-semibold rounded-md shadow hover:bg-gray-700 transition duration-150"
            >
              <i className="fas fa-arrow-left"></i>
              Previous
            </button>

            {/* Start Again Button */}
            <button
              onClick={onReset}
              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-md shadow hover:bg-blue-700 transition duration-150"
            >
              <i className="fas fa-rotate-right"></i>
              Start Again
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Appointment;
